import {
  GET_POSTS_SEARCH,
  CLEAR_POSTS_SEARCH
} from './constants';

export function searchPosts({ tags, page, category }) {
  return dispatch => dispatch({
    type: GET_POSTS_SEARCH,
    request: {
      method: 'GET',
      endpoint: 'posts/',
      queryParams: {
        category,
        tags,
        page
      }
    }
  });
}

export function clearPosts() {
  return dispatch => dispatch({
    type: CLEAR_POSTS_SEARCH
  });
}



// WEBPACK FOOTER //
// ./src/redux/PostsSearch/actions.js